import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import SEO from "@/components/SEO";

export default function NotFound() {
    const { lang } = useLang();
    const en = lang === "en";
    return (
        <div data-testid="not-found-page" className="bg-abnormal-ink min-h-[60vh] flex items-center">
            <SEO title={en ? "Page not found" : "Pagina non trovata"} description="404" path="/404" noindex />
            <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-24">
                <p className="label-mono text-abnormal-acid">// 404</p>
                <h1 className="mt-3 font-display uppercase leading-[0.85] tracking-tighter text-abnormal-paper text-4xl sm:text-5xl lg:text-6xl">
                    {en ? "Wrong line" : "Linea sbagliata"}<span className="text-abnormal-acid">.</span>
                </h1>
                <p className="mt-5 max-w-xl text-abnormal-paperDim text-base md:text-lg">
                    {en ? "This page doesn't exist (or moved). Pick a trail or head to the shop." : "Questa pagina non esiste (o si è spostata). Scegli un trail o vai allo shop."}
                </p>
                <div className="mt-8 flex flex-wrap gap-3">
                    <Link to="/" data-testid="notfound-home" className="btn-primary">{en ? "HOME" : "HOME"}</Link>
                    <Link to="/trail" data-testid="notfound-trails" className="btn-ghost">TRAIL</Link>
                    <Link to="/shop" data-testid="notfound-shop" className="btn-ghost">SHOP</Link>
                </div>
            </div>
        </div>
    );
}
